/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {VatRate} from './vat-rate.model';

export class InvoiceItemDTO {
  uuid: string | undefined = undefined;
  shipmentDate: string | undefined = undefined;
  vatRate: VatRate | undefined = undefined;
  shipmentSeries: string | undefined = undefined;
  serviceName: string | undefined = undefined;
  orderNumber: string | undefined = undefined;
  pieceNumber: string | undefined = undefined;
  weight: number | undefined = undefined;
  volume: number | undefined = undefined;
  customDutyType: string | undefined = undefined;
  sender: string | undefined = undefined;
  receiver: string | undefined = undefined;
  totalNetPrice: number | undefined = undefined;
  vatRatePrice: number | undefined = undefined;
  totalPriceAmount: number | undefined = undefined;
  vatExemptionReason: string | null | undefined = undefined;
}
